import React, { useEffect } from "react";
import "./Transition.css";
import { useNavigate } from 'react-router-dom';
import { generateMentorRecommendations } from "../../stores/recommendations/mentorRecommendationsSlice";
import { useAppDispatch } from "../../app/store";

export const NAME_URL_PARAM = "name";
export const SESSION_ID_URL_PARAM = "sessionId";
export const TIMESTAMP_START_URL_PARAM = "timestampStart";

const Transition = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const userId = urlParams.get(NAME_URL_PARAM);
    const sessionId = urlParams.get(SESSION_ID_URL_PARAM);
    const timestampStart = urlParams.get(TIMESTAMP_START_URL_PARAM);

    if (!userId || !sessionId || !timestampStart) {
      console.info("Missing URL parameters");
      navigate("/recommenderpage");
      return;
    }

    const generateAndNavigateRecommendations = async () => {
      try {
        const recommendations = await dispatch(
          generateMentorRecommendations({
            userId,
            sessionId,
            timestampStart,
          })
        ).unwrap();

        const targetPage =
          recommendations.recommendedPages.length > 0
            ? `/recommenderpage${recommendations.recommendedPages[0].pageRoute}`
            : "/recommenderpage";

        navigate(targetPage);
      } catch (error) {
        console.error("Failed to generate recommendations:", error);
        navigate("/recommenderpage");
      }
    };

    generateAndNavigateRecommendations();
  }, [dispatch, navigate]);

  return (
    <div>
        <div className="loading-screen">
          <div className="dots">
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </div>
          <p className="loading-text">
            Gathering recommendations<br/> for next
            steps in your career exploration ...
          </p>
        </div>
    </div>
  );
};

export default Transition;
